<template style="background-color: orange;">
  <header id="header">
    <div class="toggle-icon" @click="$emit('toggleSideBar')">
      <i class="fa fa-bars"></i>
    </div>
    <div class="row">
      <div class="col-lg-8 col-md-7 col-sm-6 col-6">
        <!-- <div class="tempDiv"></div> -->
        <!-- <img src="@/assets/i/logoClaimDark.png" class="img-fluid" /> -->
        <WebHeaderLocationMenu></WebHeaderLocationMenu>
      </div>
      <div
        class="
          flex-end
          col-lg-4 col-md-5 col-sm-6 col-6
          text-right
          d-flex
          align-items-center
          justify-content-end
        "
      >
        <nav>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn variant="outlined" class="d-flex justify-space-between" v-bind="attrs" v-on="on">
                {{ username }}
                <v-icon small right> mdi-chevron-down </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                @click="goToRoute('UserLocationList')"
                v-if="identity && identity.user_role <=2 && headerMenu !== 'admin_menu'"
              >
                <v-list-item-title>{{
                  $t("lang.header.menu_title_3")
                }}</v-list-item-title>
              </v-list-item>

              <v-list-item
                @click="goToRoute('dashboard')"
                v-if="headerMenu !== `dashboard_menu`"
              >
                <v-list-item-title>{{
                  $t("lang.dashboard.page_title")
                }}</v-list-item-title>
              </v-list-item>

              <v-list-item
                @click="goToRoute('PrintOrderList')"
                v-if="identity && identity.user_role <= 4 && headerMenu !== `printer_menu`"
              >
                <v-list-item-title>{{ `Printer` }}</v-list-item-title>
              </v-list-item>

              <v-list-item @click.prevent="logout">
                <v-list-item-title>{{
                  $t("lang.header.menu_title_4")
                }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
// import { mapGetters } from "vuex";
import WebHeaderLocationMenu from "../../components/layout/WebHeaderLocationMenu";

export default {
  name: "web-header",
  props: ["showSideMenu"],
  data() {
    return {
      identity: null,
      currMenu: null
    };
  },
  components: {
    WebHeaderLocationMenu
  },
  async mounted() {
    let type = localStorage.getItem("dashboard_type") || "dashboard_menu";
    this.$emit("update:showSideMenu", type);
    this.identity = await this.$api.user.identity();
    this.currMenu = await this.showCurrentMenu();
  },
  methods: {
    logout() {
      localStorage.clear();
      this.$api.auth.logout();
      this.$router.push("/");
    },
    goToRoute(route) {
      if (localStorage.getItem("dashboard_type") === route) return;
      // localStorage.setItem("dashboard_type", route);
      let type =
        route === "dashboard"
          ? "dashboard_menu"
          : route === "UserLocationList"
          ? "admin_menu"
          : "printer_menu";
      this.$emit("update:showSideMenu", type);
      this.currMenu = type;
      this.$router.push({ name: route });
    },
    showCurrentMenu() {
      let currMenu = localStorage.getItem("dashboard_type") || "dashboard_menu";
      return currMenu;
    }
  },
  computed: {
    username: function() {
      return this.$store.state.user.user;
    },
    headerMenu: function() {
      return this.$store.getters.showSideMenu;
    },
    brandMenu: {
      get() {
        return this.$store.getters.brandMenu;
      },
      set(data) {
        this.$store.dispatch("setBrandMenu", data);
      }
    }
  }
};
</script>
<style scoped>
.tempDiv {
  height: 72px;
}

@media screen and (max-width: 768px) {
  .tempDiv {
    height: 45px;
  }
}

@media screen and (orientation: landscape) {
  .tempDiv {
    height: 45px;
  }
}
</style>
